/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fairusefactorstitle3Inputs */

const id_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktor Kunci yang Membenarkan Penggunaan Wajar:`)
};

const ms_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktor Utama yang Menjustifikasikan Penggunaan Adil:`)
};

const da_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nøglefaktorer der Berettiger Fair Use:`)
};

const de_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wichtige Faktoren, die den fairen Gebrauch rechtfertigen:`)
};

const en_us2_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Factors Justifying Fair Use:`)
};

const es_es2_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factores clave que justifican el uso justo:`)
};

const es_mx2_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factores clave que justifican el uso justo:`)
};

const fil_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pangunahing Salik na Nagbibigay-katwiran sa Patas na Paggamit:`)
};

const fr_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facteurs clés justifiant l'utilisation équitable :`)
};

const it_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fattori chiave che giustificano il fair use:`)
};

const hu_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fair use-t igazoló kulcsfontosságú tényezők:`)
};

const nl_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belangrijkste factoren die fair use rechtvaardigen:`)
};

const no_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nøkkelfaktorer som rettferdiggjør rimelig bruk:`)
};

const pl_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kluczowe czynniki uzasadniające dozwolony użytek:`)
};

const pt_br2_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatores-chave que justificam o uso justo:`)
};

const pt_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais fatores que justificam o Uso Justo:`)
};

const ro_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factori cheie care justifică utilizarea corectă:`)
};

const fi_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohtuullista käyttöä oikeuttavat keskeiset tekijät:`)
};

const sv_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyckelfaktorer som motiverar skälig användning:`)
};

const vi_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các yếu tố chính biện minh cho sử dụng hợp lý:`)
};

const tr_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adil Kullanımı Haklı Çıkaran Temel Faktörler:`)
};

const cs_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíčové faktory ospravedlňující spravedlivé použití:`)
};

const bg_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключови фактори, оправдаващи честната употреба:`)
};

const ru_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключевые факторы, оправдывающие добросовестное использование:`)
};

const uk_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключові фактори, що виправдовують добросовісне використання:`)
};

const ar_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العوامل الرئيسية التي تبرر الاستخدام العادل:`)
};

const hi_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उचित उपयोग को उचित ठहराने वाले प्रमुख कारक:`)
};

const th_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัจจัยสำคัญที่แสดงให้เห็นถึงการใช้งานโดยชอบ:`)
};

const ja_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェアユースを正当化する主な要因：`)
};

const zh_cn2_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持合理使用的关键因素：`)
};

const zh_hant1_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支援合理使用的關鍵因素：`)
};

const ko_about_fairusefactorstitle3 = /** @type {(inputs: About_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공정 사용을 정당화하는 주요 요소:`)
};

/**
* | output |
* | --- |
* | "Key Factors Justifying Fair Use:" |
*
* @param {About_Fairusefactorstitle3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_fairusefactorstitle3 = /** @type {((inputs?: About_Fairusefactorstitle3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fairusefactorstitle3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_fairusefactorstitle3(inputs)
	if (locale === "ms") return ms_about_fairusefactorstitle3(inputs)
	if (locale === "da") return da_about_fairusefactorstitle3(inputs)
	if (locale === "de") return de_about_fairusefactorstitle3(inputs)
	if (locale === "en-US") return en_us2_about_fairusefactorstitle3(inputs)
	if (locale === "es-ES") return es_es2_about_fairusefactorstitle3(inputs)
	if (locale === "es-MX") return es_mx2_about_fairusefactorstitle3(inputs)
	if (locale === "fil") return fil_about_fairusefactorstitle3(inputs)
	if (locale === "fr") return fr_about_fairusefactorstitle3(inputs)
	if (locale === "it") return it_about_fairusefactorstitle3(inputs)
	if (locale === "hu") return hu_about_fairusefactorstitle3(inputs)
	if (locale === "nl") return nl_about_fairusefactorstitle3(inputs)
	if (locale === "no") return no_about_fairusefactorstitle3(inputs)
	if (locale === "pl") return pl_about_fairusefactorstitle3(inputs)
	if (locale === "pt-BR") return pt_br2_about_fairusefactorstitle3(inputs)
	if (locale === "pt") return pt_about_fairusefactorstitle3(inputs)
	if (locale === "ro") return ro_about_fairusefactorstitle3(inputs)
	if (locale === "fi") return fi_about_fairusefactorstitle3(inputs)
	if (locale === "sv") return sv_about_fairusefactorstitle3(inputs)
	if (locale === "vi") return vi_about_fairusefactorstitle3(inputs)
	if (locale === "tr") return tr_about_fairusefactorstitle3(inputs)
	if (locale === "cs") return cs_about_fairusefactorstitle3(inputs)
	if (locale === "bg") return bg_about_fairusefactorstitle3(inputs)
	if (locale === "ru") return ru_about_fairusefactorstitle3(inputs)
	if (locale === "uk") return uk_about_fairusefactorstitle3(inputs)
	if (locale === "ar") return ar_about_fairusefactorstitle3(inputs)
	if (locale === "hi") return hi_about_fairusefactorstitle3(inputs)
	if (locale === "th") return th_about_fairusefactorstitle3(inputs)
	if (locale === "ja") return ja_about_fairusefactorstitle3(inputs)
	if (locale === "zh-CN") return zh_cn2_about_fairusefactorstitle3(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_fairusefactorstitle3(inputs)
	return ko_about_fairusefactorstitle3(inputs)
});
export { about_fairusefactorstitle3 as "about.fairUseFactorsTitle" }